/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato =
  (typeof EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato)[keyof typeof EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato = {
  SPID: 'SPID',
  CIE: 'CIE',
  EIDAS: 'EIDAS',
  LDAP: 'LDAP',
  EXTRA_UE: 'EXTRA_UE',
  CNS: 'CNS',
} as const;
